module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst controls = config.controls || {}\nconst buttons = []\nif(controls.requestOffer) {\nbuttons.push({\nusage: true,\ncontext: 'project',\nbuttonType: 'requestOffer'\n})\n}\nif(controls.request){\nbuttons.push({\nusage: true,\ncontext: 'project',\nbuttonType: 'editStatus',\nmode: 'request',\n})\n}\nif(controls.order){\nbuttons.push({\nusage: true,\ncontext: 'project',\nbuttonType: 'editStatus',\nmode: 'order',\n})\n}\nif(controls.cancel){\nbuttons.push({\nusage: true,\ncontext: 'project',\nbuttonType: 'editStatus',\nmode: 'cancel',\n})\n}\n%><div><%\nif(buttons.length > 0){\n%><%- include('../../core/form/elements/buttons', { formMapping: { buttons }}) %><%\n}\n%></div>"
  , __filename = "components/templates/customers/projects/propertiesStatusControls.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const controls = config.controls || {}
const buttons = []
if(controls.requestOffer) {
buttons.push({
usage: true,
context: 'project',
buttonType: 'requestOffer'
})
}
if(controls.request){
buttons.push({
usage: true,
context: 'project',
buttonType: 'editStatus',
mode: 'request',
})
}
if(controls.order){
buttons.push({
usage: true,
context: 'project',
buttonType: 'editStatus',
mode: 'order',
})
}
if(controls.cancel){
buttons.push({
usage: true,
context: 'project',
buttonType: 'editStatus',
mode: 'cancel',
})
}

    ; __line = 35
    ; __append("<div>")
    ; 
if(buttons.length > 0){

    ; __line = 37
    ; __append( include('../../core/form/elements/buttons', { formMapping: { buttons }}) )
    ; 
}

    ; __line = 39
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/customers/projects/propertiesStatusControls.ejs

}